import { render, staticRenderFns } from "./messageBox.vue?vue&type=template&id=7b619afa&scoped=true"
import script from "./messageBox.vue?vue&type=script&lang=js"
export * from "./messageBox.vue?vue&type=script&lang=js"
import style0 from "./messageBox.vue?vue&type=style&index=0&id=7b619afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b619afa",
  null
  
)

export default component.exports